import { combineReducers } from 'redux';

import {
    REQUEST_BANK_CREDIT_CARD,
    RECEIVE_BANK_CREDIT_CARD,
    FAILURE_BANK_CREDIT_CARD
} from './constants';

const bankcreditcard = (state = {}, action) => {
    switch (action.type) {
        case RECEIVE_BANK_CREDIT_CARD:
            return action.response.payload;
        default:
            return state;
    }
};

const fetching = (state = false, action) => {
    switch (action.type) {
        case REQUEST_BANK_CREDIT_CARD:
            return true;
        case FAILURE_BANK_CREDIT_CARD:
        case RECEIVE_BANK_CREDIT_CARD:
            return false;
        default:
            return state;
    }
};

const error = (state = '', action) => {
    switch (action.type) {
        case FAILURE_BANK_CREDIT_CARD:
            return action.response.message;
        case REQUEST_BANK_CREDIT_CARD:
        case RECEIVE_BANK_CREDIT_CARD:
            return '';
        default:
            return state;
    }
};

export default combineReducers({
    bankcreditcard,
    fetching,
    error
});



// WEBPACK FOOTER //
// ./src/services/bankcreditcard/reducer.js